import { mString } from 'lib/helpers/utility';

import OtherAdjustment from '../components/OtherAdjustment';

export const colDefs = [
  {
    field: 'procedure_code',
    headerName: 'Procedure Code',
    flex: 1,
    sortable: false,
    cellClass: 'no-border'
  },
  {
    field: 'charge',
    headerName: 'Charge',
    valueFormatter: ({ value }) => mString(value || 0),
    sortable: false,
    cellClass: 'no-border'
  },
  {
    field: 'other_adj',
    headerName: 'Adjustment Amount',
    flex: 1,
    sortable: false,
    cellStyle: { padding: '0' },
    cellClass: 'no-border',
    cellRenderer: OtherAdjustment
  }
];

export const DEFAULT_COL_DEFS = { enableRowGroup: true, resizable: true };
